export default {"src":"/_next/static/media/kiosk-touch.ab97ca82.svg","height":66,"width":65,"blurWidth":0,"blurHeight":0};